module.exports = __webpack_public_path__ + "static/scale-model-of-billings-van-&-shuttle-in-billings-montana-b1e5a0349ee10eac15639818c84659e8.png";